<template>
  <div class="el-section">
    <div class="emd-container">
      <div class="emd-container__header eu-py_4_md eu-px_5_md">
        <h2 class="emd-text _size_section _color_default">
          {{ $t('title') }}
        </h2>
      </div>
      <hr class="emd-divider">
      <div class="emd-container__content eu-pa_5_md">
        <emd-alert v-if="showAlert" variant="danger" @cancel="showAlert = false" :title="$t('error.title')">
          <template slot="content">
            <p v-for="(error, index) in errors" :key="index" v-html="error.message"></p>
          </template>
        </emd-alert>
          <div class="eu-flex">

            <section class="el-chunk eu-flex-item eu-basis_4_lg eu-basis_6_md eu-basis_12">
              <div class="el-chunk">
                <h2>
                  <strong>{{ $t('customer.client') }}</strong>
                </h2>
              </div>
              <div class="el-chunk">
                <div class="el-grid-list _auto-fill">
                  <div class="emd-container _type_card">
                    <div class="emd-container__content">
                      <div class="el-chunk">
                        <h3>
                          {{ customer.name }}
                        </h3>
                      </div>
                      <p class="emd-text _size_small eu-text-overflow">{{ customer.email }}</p>
                      <p class="emd-text _size_small">{{ formatDocument(customer.document) }}</p>
                      <p class="emd-text _size_small" v-if="customer.mobile_phone.length">{{ formatPhoneNumber(customer.mobile_phone) }}</p>
                      <p class="emd-text _size_small" v-if="customer.home_phone.length">{{ formatPhoneNumber(customer.home_phone) }}</p>
                    </div>
                  </div>
                  <div class="emd-container _type_card" v-if="address.show_address">
                    <div class="emd-container__content">
                      <div class="el-chunk">
                        <h3>
                          {{ $t('customer.address') }}
                        </h3>
                      </div>
                      <p class="emd-text _size_small">{{ formatZipCode(address.zip_code) }}</p>
                      <p class="emd-text _size_small">{{ address.street }}, {{ address.number }}</p>
                      <p class="emd-text _size_small">{{ address.neighborhood }}</p>
                      <p class="emd-text _size_small">{{ address.city }} - {{ address.state }} - {{ address.country }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="el-chunk eu-flex-item eu-basis_4_lg eu-basis_6_md eu-basis_12">
              <div class="el-chunk">
                <h2>
                  <strong>{{ $t('payment.method') }}</strong>
                </h2>
              </div>
              <div class="el-grid-list _auto-fill">
                <payment-details
                  :installment-value="calculateInstallmentValue"
                  :payment-method="selectedPaymentMethod"
                  :credit-card="credit_card"
                  :checkout="checkout"
                  :card="card"
                />
                <div class="emd-container _type_card" v-if="selectedPaymentMethod === 'boleto'">
                  <div class="emd-container__content">
                    <div class="el-chunk">
                      <h3>
                        {{ $t(`payment.${selectedPaymentMethod}`) }}
                      </h3>
                    </div>
                    <p class="emd-text _size_small">Válido até: {{ payment.due_at }}</p>
                    <p class="emd-text _size_small">Instruções: {{ payment.instructions.length ? normalizeCharacteres(payment.instructions) : '-' }}</p>
                    <p class="emd-text _size_small">Valor: {{ totalAmount }}</p>
                  </div>
                </div>
                <div class="emd-container _type_card" v-if="showBillingAddress && this.selectedPaymentMethod !== 'pix'">
                  <div class="emd-container__content">
                    <div class="el-chunk">
                      <h3>
                        {{ $t('payment.address') }}
                      </h3>
                    </div>
                    <p class="emd-text _size_small">{{ formatZipCode(billingAddress.zip_code) }}</p>
                    <p class="emd-text _size_small">{{ billingAddress.street }}, {{ billingAddress.number }}</p>
                    <p class="emd-text _size_small">{{ billingAddress.neighborhood }}</p>
                    <p class="emd-text _size_small">{{ billingAddress.city }} - {{ billingAddress.state }} - {{ billingAddress.country }}</p>
                  </div>
                </div>
              </div>

            </section>
            <section class="el-chunk eu-flex-item eu-basis_4_lg eu-basis_12" v-if="selectedPaymentType === 'items' || selectedPaymentType === 'typed-sale'">
              <div class="el-chunk">
                <h2>
                  <strong>{{ $t('items') }}</strong>
                </h2>
              </div>
              <div class="el-grid-list _auto-fill">
                <div class="el-chunk">
                  <div class="emd-container _type_card">
                    <div class="emd-container__content">
                      <table class="eu-width_100">
                        <tbody>
                          <tr v-for="(item, index) in items" :key="index">
                            <td class="eu-pb_1">
                              <span class="emd-text _size_small">
                                {{ item.description }}
                              </span>
                              <span class="emd-badge _type_round">x{{ item.quantity }}</span>
                            </td>
                            <td  class="eu-pb_1 emd-text _size_small _align_right">
                              {{ formatCurrency((formatToInt(item.amount) * item.quantity) / 100) }}
                            </td>
                          </tr>
                          <tr class="eu-border-top" v-if="formatToInt(shipping.amount)">
                            <td class="eu-py_2">
                              <span class="emd-text _size_small">
                                Frete
                              </span>
                            </td>
                            <td class="emd-text _size_small _align_right">
                              {{ shipping.amount }}
                            </td>
                          </tr>
                          <tr class="eu-border-top">
                            <td class="emd-text _type_caption _size_small eu-pt_2">{{ $t('total') }}</td>
                            <td class="emd-text _type_caption _align_right eu-pt_2">{{ totalAmount }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <order-code-details />
                </div>
              </div>
            </section>

            <section class="el-chunk eu-flex-item eu-basis_4_lg eu-basis_12" v-else-if="selectedPaymentType !== 'typed-sale'">
              <div class="el-chunk">
                <p>
                  <strong>{{ $t('subscription.title') }}</strong>
                </p>
              </div>
              <div class="el-chunk">
                <div class="el-grid-list _size_small">
                  <div class="emd-container _type_card eu-height_100">
                    <div class="emd-container__content">
                      <div class="el-chunk">
                        <p class="emd-text">{{ items[0].description }}</p>
                      </div>
                      <p class="emd-text _type_caption eu-pb_1">{{ $t(`subscription.amount.${subscription.interval}`, {price: items[0].price, interval: subscription.interval_count}) }}</p>
                      <p class="emd-text _type_caption" v-if="items[0].cycle">{{ $t('subscription.interval', {cycle: items[0].cycle}) }}</p>
                      <p class="emd-text _type_caption">{{ $t('subscription.start', {start: subscription.start_at}) }}</p>
                    </div>
                  </div>

                  <div class="emd-container _type_card eu-height_100" v-if="formatToInt(subscription.setup.amount)">
                    <div class="emd-container__content">
                      <div class="el-chunk">
                        <h3>{{ $t('subscription.setup') }}</h3>
                      </div>
                      <div class="el-chunk">
                        <p class="emd-text">{{ subscription.setup.description }}</p>
                      </div>
                      <p class="emd-text _type_caption">{{ subscription.setup.amount }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
      </div>
    </div>

    <div class="el-section">
      <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
          <button class="emd-btn _color_secondary _type_text _block_mobile" @click="reverseRoute" :disabled="loading">
            <i class="uil uil-angle-left"></i>
            {{ $t(`paymentData`) }}
          </button>
          <button class="emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm" :disabled="loading" @click="createOrder">
            <emd-loader v-if="loading" />
            <span v-else-if="selectedPaymentType === 'subscription'">{{ $t(`finish.${selectedPaymentType}`) }}</span>
            <span v-else>{{ $t(`finish.${selectedPaymentMethod}`) }}</span>
          </button>
      </div>
    </div>

  </div>
</template>

<script>
import { formatCurrency, prepareItems, isEmpty, formatPhoneNumberToRequest, formatISODate, formatToInt, formatDocument, formatZipCode, formatPhoneNumber, formatDate, maskCreditCard, normalizeCharacteres, formatDateToLocalTime } from '@/utils/validations'
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import EmdLoader from '@/components/emerald/atoms/EmdLoader'
import PaymentDetails from '../../components/project/PaymentDetails.vue'
import OrderCodeDetails from '@/components/project/ReviewOrder/OrderCodeDetails.vue'

export default {
  name: 'ReviewOrder',
  components: {
    EmdAlert,
    EmdLoader,
    PaymentDetails,
    OrderCodeDetails
  },
  data () {
    return {
      body: {},
      card_token: {},
      showAlert: false,
      loading: false,
      errors: [],
      creditCardTokenHasError: false
    }
  },
  computed: {
    customer () {
      return this.$store.getters.customer
    },
    address () {
      return this.$store.getters.address
    },
    billingAddress () {
      if (this.$store.getters.billing_address.use_client_address) return this.$store.getters.address
      else return this.$store.getters.billing_address
    },
    shipping () {
      return this.$store.getters.shipping
    },
    totalAmount () {
      return this.$store.getters.total.amount
    },
    items () {
      if (this.selectedPaymentType === 'items' || this.selectedPaymentType === 'typed-sale') return this.$store.getters.items
      else return this.$store.getters.itemSubscription
    },
    selectedPaymentMethod () {
      return this.$store.getters.selectedPaymentMethod
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    subscription () {
      return this.$store.getters.subscription
    },
    createdOrderResponse () {
      return this.$store.getters.createdOrderResponse
    },
    payment () {
      if (this.selectedPaymentMethod === 'checkout') return this.checkout
      else if (this.selectedPaymentMethod === 'credit_card') return this.card
      else return this.$store.getters.boleto
    },
    checkout () {
      return this.$store.getters.checkout
    },
    card () {
      return this.$store.getters.card
    },
    credit_card () {
      return this.$store.getters.credit_card
    },
    imageURL () {
      return `${process.env.VUE_APP_CDN_URL}/assets/images/logos/brands/png/${this.payment.label.toLowerCase()}.png`
    },
    publicKey () {
      return this.$store.getters.accountSummary.public_key
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    calculateInstallmentValue () {
      if (this.selectedPaymentType === 'items' || this.selectedPaymentType === 'typed-sale') {
        return formatCurrency((formatToInt(this.totalAmount) / parseInt(this.credit_card.installments)) / 100)
      }
      return formatCurrency((formatToInt(this.items[0].price) +
                             formatToInt(this.subscription.setup.amount) /
                             parseInt(this.credit_card.installments)) /
                             100)
    },
    orderCreatedRoute () {
      return this.$store.getters.routesWizard.find(route => {
        return route.path === 'order-created'
      })
    },
    pref () {
      return this.$store.getters.pref
    },
    mode () {
      return this.pref?.appearance?.mode
    },
    showBillingAddress () {
      return this.billingAddress.show_address || this.billingAddress.use_client_address
    },
    pix () {
      return this.$store.getters.pix
    }
  },
  methods: {
    formatCurrency: formatCurrency,
    formatDocument: formatDocument,
    formatZipCode: formatZipCode,
    formatPhoneNumber: formatPhoneNumber,
    formatDate: formatDate,
    maskCreditCard: maskCreditCard,
    formatToInt: formatToInt,
    isEmpty: isEmpty,
    normalizeCharacteres: normalizeCharacteres,
    buildStatementDescriptorValue () {
      if (this.selectedPaymentMethod === 'credit_card') {
        if (!isEmpty(this.credit_card.statement_descriptor)) {
          return this.credit_card.statement_descriptor
        }
      } else if (!isEmpty(this.payment.credit_card.statement_descriptor)) {
        return {
          statement_descriptor: this.payment.credit_card.statement_descriptor
        }
      }
    },
    setOrderCode () {
      return this.$store.getters.orderCode ? this.$store.getters.orderCode : null
    },
    isReadOnlyPermission (action) {
      if (action === 'CREATE_ORDER') {
        if (!this.$store.getters.permissionIsEnabled('shop.checkout:create')) {
          this.showReadOnlyAlert()
        } else {
          return true
        }
      }
      if (action === 'CREATE_SUBSCRIPTION') {
        if (!this.$store.getters.permissionIsEnabled('shop.recurrence:create')) {
          this.showReadOnlyAlert()
        } else {
          return true
        }
      }
    },
    showReadOnlyAlert () {
      this.errors = [this.$t('error.readOnly')]
      this.showAlert = true
      this.loading = false
    },
    setType () {
      if (this.customer.document.length === 14) return 'company'
      return 'individual'
    },
    setSubscription (subscription = {}) {
      if (formatToInt(this.subscription.setup.amount)) {
        subscription.setup = {
          amount: formatToInt(this.subscription.setup.amount),
          description: this.subscription.setup.description,
          statement_descriptor: this.buildStatementDescriptorValue()
        }
        if (isEmpty(subscription.setup.description)) delete subscription.setup.description
      }
      subscription.interval = this.subscription.interval
      subscription.interval_count = this.subscription.interval_count
      subscription.start_at = formatISODate(this.subscription.start_at)
      return subscription
    },
    getBusinessModel () {
      return this.$store.getters.business_model
    },
    isPSP () {
      return this.getBusinessModel === 'p_s_p'
    },
    setCustomer (customer = {}) {
      customer.name = this.customer.name
      customer.email = this.customer.email.toLowerCase()
      customer.type = this.setType()
      if (this.customer.document.length) customer.document = this.customer.document
      if (this.customer.mobile_phone.length) customer.mobile_phone = formatPhoneNumberToRequest(this.customer.mobile_phone)
      if (this.customer.home_phone.length) customer.home_phone = formatPhoneNumberToRequest(this.customer.home_phone)
      if (this.address.show_address) customer.address = this.address
      return customer
    },
    setCheckout () {
      const checkout = { ...this.payment }
      if (checkout.accepted_payment_methods.includes('credit_card')) {
        let helper = {}
        const hasAuthAndCapture = this.payment.credit_card.operation_type === 'auth_and_capture'
        if (hasAuthAndCapture) {
          helper = {
            capture: true,
            operation_type: 'auth_and_capture'
          }
        } else {
          helper = {
            capture: false,
            operation_type: 'auth_only'
          }
        }
        checkout.credit_card = {
          installments: parseInt(this.payment.credit_card.installments),
          ...this.buildStatementDescriptorValue(),
          ...helper
        }
      } else delete checkout.credit_card
      if (checkout.accepted_payment_methods.includes('boleto')) checkout.boleto.due_at = formatISODate(this.payment.boleto.due_at)
      else delete checkout.boleto
      this.shouldSetCheckoutPixPaymentMethod(checkout)
      checkout.expires_in = parseInt(this.payment.expires_in)
      return checkout
    },
    shouldSetCheckoutPixPaymentMethod (checkout) {
      if (checkout.accepted_payment_methods.includes('pix')) {
        checkout.pix = {
          expires_at: formatDateToLocalTime(this.payment.pix.expires_at)
        }
      } else delete checkout.pix
    },
    async setCreditCard (body) {
      await this.$store.dispatch('CREATE_CARD_TOKEN', body)
        .then((res) => {
          this.credit_card.card_token = res.id
        })
        .catch(() => {
          this.errors = [this.$t('error.credit_card')]
          this.showAlert = true
          this.creditCardTokenHasError = true
          this.loading = false
        })
    },
    async setPayments (payments = []) {
      if (this.selectedPaymentMethod === 'boleto') {
        const boleto = {
          boleto: {
            due_at: formatISODate(this.payment.due_at),
            instructions: normalizeCharacteres(this.payment.instructions),
            billing_address: this.setBillingAddress()
          }
        }

        payments.push(boleto)
      }
      if (this.selectedPaymentMethod === 'checkout') {
        payments.push({ checkout: this.setCheckout() })
      }
      if (this.selectedPaymentMethod === 'credit_card') {
        const card = { type: 'card', card: this.payment }
        const body = {
          public_key: this.publicKey,
          card: card
        }
        await this.setCreditCard(body)

        if (this.card.operation === 'auth_only') {
          this.credit_card.capture = false
          this.credit_card.operation_type = 'auth_only'
        } else { delete this.credit_card.operation_type }

        this.credit_card.card = { billing_address: this.setBillingAddress() }
        this.credit_card.statement_descriptor = this.buildStatementDescriptorValue()

        payments.push({ credit_card: this.credit_card })
      }
      if (this.selectedPaymentMethod === 'pix') {
        this.setPixPayment(payments)
      }
      if (this.selectedPaymentType === 'items' || this.selectedPaymentType === 'typed-sale') return payments
      return payments[0]
    },
    setPixPayment (payments) {
      const pix = {
        pix: {
          expires_at: formatDateToLocalTime(this.pix.expires_at)
        }
      }
      payments.push(pix)
    },
    shouldSetPixQrCode (res) {
      if (this.selectedPaymentMethod === 'pix') {
        this.pix.qr_code_url = res.payments[0].qr_code_url
        this.pix.qr_code = res.payments[0].qr_code
      }
    },
    setBillingAddress () {
      if (this.billingAddress.use_client_address) return this.address
      else if (this.billingAddress.street.length) return this.billingAddress
    },
    setItems (items = []) {
      if (this.selectedPaymentType === 'items' || this.selectedPaymentType === 'typed-sale') {
        this.items.map(item => items.push(item))
        if (this.shipping.amount !== 'R$ 0,00' || isEmpty(this.shipping.amount)) {
          const shipping = { ...this.shipping }
          items.push(shipping)
        }
        return prepareItems(items)
      } else {
        items = {
          price: formatToInt(this.items[0].price),
          description: this.items[0].description,
          quantity: parseInt(this.items[0].quantity)
        }
        if (formatToInt(this.items[0].cycle)) items.cycle = this.items[0].cycle
      } return [items]
    },
    async setParams () {
      const subscription = this.selectedPaymentType === 'subscription' ? this.setSubscription() : {}
      let params
      if (this.selectedPaymentType === 'subscription') {
        params = {
          merchantId: this.merchantId,
          accountId: this.accountId,
          body: Object.assign(subscription, {
            customer: this.setCustomer(),
            items: this.setItems(),
            payment: await this.setPayments()
          })
        }
      } else {
        params = {
          merchantId: this.merchantId,
          accountId: this.accountId,
          body: Object.assign(subscription, {
            order_code: this.setOrderCode(),
            customer: this.setCustomer(),
            items: this.setItems(),
            payments: await this.setPayments()
          })
        }
      }
      return params
    },
    async createOrder () {
      const pixCreateOrderSuccessLabel = 'Pedido do tipo checkout pix criado com sucesso'
      const pixCreateOrderErrorLabel = 'Erro ao criar um pedido do tipo checkout pix'
      if (!this.loading) {
        this.loading = true
        const params = await this.setParams()
        const action = (this.selectedPaymentType === 'items' || this.selectedPaymentType === 'typed-sale') ? 'CREATE_ORDER' : 'CREATE_SUBSCRIPTION'
        if (!this.creditCardTokenHasError && this.isReadOnlyPermission(action)) {
          this.$store.dispatch(action, params)
            .then(res => {
              if (res.status === 'failed') {
                this.shouldTrackPixPaymentMethodCreateOrder(action, pixCreateOrderErrorLabel)
                this.errors = [this.$t('error.default')]
                this.showAlert = true
                this.loading = false
              } else {
                this.shouldTrackPixPaymentMethodCreateOrder(action, pixCreateOrderSuccessLabel)
                this.shouldSetPixQrCode(res)
                this.orderCreatedRoute.permission = true
                this.nextRoute()
              }
            })
            .catch(err => {
              if (err.body.errors) this.errors = [...err.body.errors]
              else this.errors = [this.$t('error.default')]
              this.loading = false
              this.showAlert = true
              this.shouldTrackPixPaymentMethodCreateOrder(action, pixCreateOrderErrorLabel)
            })
        } else this.creditCardTokenHasError = false
      }
    },
    nextRoute () {
      this.$router.push({ name: 'OrderCreated' })
    },
    shouldTrackPixPaymentMethodCreateOrder (action, label) {
      if (action === 'CREATE_ORDER' && this.checkout.accepted_payment_methods.includes('pix') && ['production'].includes(process.env.VUE_APP_CORE_ENV)) {
        this.$gtag.event(`Criar pedido do tipo ${this.selectedPaymentMethod}`, {
          event_category: 'Resumo do pedido',
          event_label: label
        })
      }
    },
    reverseRoute () { this.$router.push({ name: 'PaymentData' }) }
  },
  beforeMount () {
    if (this.selectedPaymentMethod === 'checkout') this.billingAddress.show_address = false
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Confirme os dados do pedido para finalizar",
      "items": "Itens do pedido",
      "total": "Total",
      "customer": {
        "client": "Cliente",
        "address": "Endereço"
      },
      "payment": {
        "address": "Endereço de cobrança",
        "method": "Detalhes de Pagamento",
        "checkout": {
          "title": "Link de Pagamento",
          "subtitle": "Gerar link de pagamento, permitindo:",
          "boleto": "- Boleto com vencimento em",
          "credit_card": "- Cartão de crédito"
        },
        "credit_card": "Cartão de Crédito",
        "boleto": "Boleto",
        "operation": {
          "label": "Operação do cartão de crédito:",
          "auth_and_capture": "Autorizar e capturar",
          "auth_only": "Autorizar somente"
        }
      },
      "finish": {
        "boleto": "Gerar Boleto",
        "checkout": "Gerar link",
        "credit_card": "Pagar com Cartão de Crédito",
        "pix": "Gerar Pix",
        "subscription": "Criar recorrência"
      },
      "paymentData": "Dados de Pagamento",
      "error": {
        "title": "Erro",
        "readOnly": {
          "message": "Você não possui permissão para criar transações no Shop"
        },
        "credit_card": {
          "message": "Não foi possível finalizar o pagamento."
        },
        "boleto": {
          "message": "Não foi possível criar o boleto."
        },
        "checkout": {
          "message": "Não foi possível criar o link de pagamento."
        },
        "default": {
          "message": "Não foi possível finalizar a criação do pedido."
        }
      },
      "subscription": {
        "title": "Dados da Recorrência",
        "setup": "Dados da Adesão",
        "start": "Primeira cobrança em {start}",
        "amount": {
          "day": "{price} a cada {interval} dia(s)",
          "week": "{price} a cada {interval} semana(s)",
          "month":  "{price} a cada {interval} mês(es)",
          "year":  "{price} a cada {interval} ano(s)"
        },
        "interval": "Por {cycle} ciclo(s)"
      }
    },
    "en-US": {
      "title": "Confirm the order's data to finish",
      "items": "Order Items",
      "total": "Total",
      "customer": {
        "client": "Customer",
        "address": "Address"
      },
      "payment": {
        "address": "Billing address",
        "method": "Payment Details",
        "checkout": {
          "title": "Payment Link",
          "subtitle": "Generate payment link, allowing:",
          "boleto": "- Boleto with due date at",
          "credit_card": "- Credit Card"
        },
        "credit_card": "Credit Card",
        "boleto": "Boleto",
        "operation": {
          "label": "Credit card operation:",
          "auth_and_capture": "Authorize and capture",
          "auth_only": "Authorize only"
        }
      },
      "finish": {
        "boleto": "Generate Boleto",
        "checkout": "Generate Link",
        "credit_card": "Pay with Credit Card",
        "subscription": "Pay subscription"
      },
      "paymentData": "Payment Data",
      "error": {
        "title": "Error",
        "credit_card": {
          "message": "Could not create payment."
        },
        "boleto": {
          "message": "Could not create boleto."
        },
        "checkout": {
          "message": "Could not create payment link."
        },
        "subscription": "Subscription details"
      },
      "subscription": {
        "title": "Subscription Details",
        "setup": "Setup Details",
        "start": "Start at {start}",
        "amount": {
          "day": "{price} every {interval} day(s)",
          "week": "{price} every {interval} week(s)",
          "month":  "{price} every {interval} month(s)",
          "year":  "{price} every {interval} year(s)"
        },
        "interval": "For {cycle} cycle(s)"
      }
    }
  }
</i18n>
